import { fo_caan } from '../../../models/response/dich-vu/food/fo_caan';
import { BaseCRUDApi } from '../../baseCRUDApi';

export const API_FO_CAAN_PATH = "food/ca-an";

class FoCaAnApi extends BaseCRUDApi<fo_caan> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
}
export const foCaAnApi = new FoCaAnApi(API_FO_CAAN_PATH);
